import sunImage from "../assets/mobile-planet-images/sun-mobile.png";
import mercuryImage from "../assets/mobile-planet-images/mercury-mobile.png";
import venusImage from "../assets/mobile-planet-images/venus-mobile.png";
import earthImage from "../assets/mobile-planet-images/earth-mobile.png";
import moonImage from "../assets/mobile-planet-images/moon-mobile.png";
import marsImage from "../assets/mobile-planet-images/mars-mobile.png";
import jupiterImage from "../assets/mobile-planet-images/jupiter-mobile.png";
import saturnImage from "../assets/mobile-planet-images/saturn-mobile.png";
import uranusImage from "../assets/mobile-planet-images/uranus-mobile.png";
import neptuneImage from "../assets/mobile-planet-images/neptune-mobile.png";
import plutoImage from "../assets/mobile-planet-images/pluto-mobile.png";

export const planetImages = {
  sun: sunImage,
  mercury: mercuryImage,
  venus: venusImage,
  earth: earthImage,
  moon: moonImage,
  mars: marsImage,
  jupiter: jupiterImage,
  saturn: saturnImage,
  uranus: uranusImage,
  neptune: neptuneImage,
  pluto: plutoImage,
};
